export class TopBar extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    this.scene = scene;
    this.create();
  }

  create() {
    const { width } = this.scene.game.config;
    const screenWidth = width as number;

    const topbar = this.scene.add.sprite(screenWidth / 2, 100, 'topbar').setDepth(1);
    topbar.setDisplaySize(screenWidth + 20, 210);
  }
}
